import { faMusic, faVideo } from '@fortawesome/pro-light-svg-icons'

import {
  minMaxRule,
  requiredRule,
  validNftSalesFeeRule,
  validUrlRule
} from './validation.helpers'
import { COLOR_PALETTE } from '../constants/theme'
import { NFT_MEDIA_TYPES } from '../constants/nfts'
import { NFTS_LIST_PROFILE_DISPATCH } from '../store/reducers/nfts/nftsList'
import { NFT_YES_NO_OPTIONS } from '../data/nfts'
import { tokenMetaDescription } from './token.helpers'
import {
  NFT_NAME_MAX_LENGTH,
  POINT_SYMBOL_MIN_LENGTH
} from '../constants/validation'

const buildNftValidationRules = ({
  media,
  mediaUrl,
  name,
  type,
  supply,
  externalLink,
  userSale,
  userTransfer,
  userSalesFee,
  showNft
}) => {
  return {
    ...(!mediaUrl && { media: { value: media, rules: [requiredRule] } }),
    name: {
      value: name,
      rules: [
        requiredRule,
        minMaxRule(POINT_SYMBOL_MIN_LENGTH, NFT_NAME_MAX_LENGTH)
      ]
    },
    type: { value: type, rules: [requiredRule] },
    supply: { value: supply, rules: [requiredRule] },
    externalLink: { value: externalLink, rules: [validUrlRule] },
    userSale: { value: userSale, rules: [requiredRule] },
    userTransfer: { value: userTransfer, rules: [requiredRule] },
    ...(convertToBoolean(userSale) && {
      userSalesFee: {
        value: userSalesFee,
        rules: [requiredRule, validNftSalesFeeRule]
      }
    }),
    showNft: { value: showNft, rules: [requiredRule] }
  }
}

const nftFieldsFormat = (nft, mediaUrl, tokenOnramp) => {
  const {
    name,
    type,
    supply,
    description,
    exclusiveContent,
    externalLink,
    pointValue,
    showNft,
    userSale,
    userTransfer,
    userSalesFee,
    media
  } = nft
  const mediaType = media?.type.split('/')[0]
  const onramp = tokenOnramp * pointValue
  return {
    nft: {
      name,
      supply,
      nft_type: type,
      can_redeem: convertToBoolean(showNft),
      sales_fee_percentage: userSalesFee,
      can_transfer: convertToBoolean(userTransfer),
      can_sell: convertToBoolean(userSale),
      onramp,
      metadata: {
        ...tokenMetaDescription(description),
        external_link: externalLink,
        exclusive_content: exclusiveContent,
        media: {
          type: mediaType,
          url: mediaUrl
        }
      }
    }
  }
}

const convertToBoolean = (response) => {
  if (response === NFT_YES_NO_OPTIONS.yes) {
    return true
  }
  return false
}

const convertToYesNo = (value, t) => {
  return t(`nft.yes-no-options.${value ? 'yes' : 'no'}`)
}

const buildNftMediaIcons = (type) => {
  switch (type) {
    case NFT_MEDIA_TYPES.AUDIO:
      return faMusic
    case NFT_MEDIA_TYPES.VIDEO:
      return faVideo
  }
}

const sortNftsByDateASC = (nfts) => {
  if (nfts && nfts.length > 0) {
    return nfts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  }
  return []
}

const isNftStatusFilter = ({ property }) =>
  property === NFTS_LIST_PROFILE_DISPATCH.STATUS

const buildUpdateNftData = (showNft) => {
  return {
    token: {
      can_redeem: showNft
    }
  }
}

const buildRedeemExclCntData = (userAuthId, nftId, claimCount) => {
  return {
    user_auth_id: userAuthId,
    claim: claimCount > 0 ? -1 : 1,
    nft_id: nftId
  }
}

const buildStatusLabelColor = (exclusiveContent, claimCount) => {
  if (exclusiveContent) {
    if (claimCount > 0) {
      return {
        label: 'redeemed',
        color: COLOR_PALETTE.ERROR
      }
    } else {
      return {
        label: 'available',
        color: COLOR_PALETTE.SUCCESS
      }
    }
  }
  return {
    label: 'none',
    color: COLOR_PALETTE.GREY4
  }
}

export {
  buildNftValidationRules,
  nftFieldsFormat,
  buildNftMediaIcons,
  sortNftsByDateASC,
  isNftStatusFilter,
  buildUpdateNftData,
  buildRedeemExclCntData,
  buildStatusLabelColor,
  convertToYesNo
}
